<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <span>{{ topTitle }}</span>
        </div>
        <div class="exam-box" v-loading="loading">
          <div class="title">{{ topTitle }}</div>
          <div class="text-prc">
            {{
              "考试须知："
            }}
            <span style="display: inline-block;" v-html="data.content"></span>
          </div>
          <div class="text-prc">{{ "考试时间：" + timeToDate(data.start_time) + "至" + timeToDate(data.end_time) }}</div>
          <div class="text-prc">{{ "报名时间：" + timeToDate(data.stime) + "至" + timeToDate(data.etime) }}</div>
          <div class="class-box">
            <router-link :to="{ name: 'enroll', params: { id: examId } }">
              <div class="item">
                <img src="@/assets/icon/onlineExam.png" alt="" />
                <div class="text-prc">在线考试</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'practice', params: { id: examId,title:topTitle } }">
              <div class="item">
                <img src="@/assets/icon/practice.png" alt="" />
                <div class="text-prc">章节练习</div>
              </div></router-link
            >
            <router-link :to="{ name: 'myFaults', params: { id: starId,title:topTitle} }">
              <div class="item">
                <img src="@/assets/icon/wrongQuestion.png" alt="" />
                <div class="text-prc">错题列表</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'mySuccess', params: { id: examId,title:topTitle } }">
              <div class="item">
                <img src="@/assets/icon/myGrades.png" alt="" />
                <div class="text-prc">我的成绩</div>
              </div>
            </router-link>
            <router-link :to="{ name: 'myStart', params: {  id: starId,title:topTitle } }">
              <div class="item">
                <img src="@/assets/icon/star.png" alt="" />
                <div class="text-prc">我的收藏</div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="class-list" v-if="newsList.length > 0">
          <div class="class-title">
            {{ "最新箭闻"
            }}<router-link :to="{ name: 'article' }">
              <i style="color: rgba(152, 150, 150, 1)">{{ $t("more") }}</i>
            </router-link>
          </div>
          <div class="class-item-wrap">
            <div class="class-item" v-for="item in newsList" :key="item.id" @click="newsDetail(item.id)">
              <div
                class="videp-cover"
                :style="{
                  backgroundImage: `url(${item.cover})`,
                  backgroundSize: 'cover',
                }"
              ></div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      topTitle: "详情",
      examId: "",
      id: "",
      starId: "",
      newsList: [],
      data: {},
      news: [],
    };
  },
  computed: {
    timeToDate() {
      return (time) => {
        var date = new Date(time * 1000); //如果date为13位不需要乘1000
        var Y = date.getFullYear() + "-";
        var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var s = ":" + date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m;
      };
    },
  },
  mounted() {
    sessionStorage.setItem("nowPageData", JSON.stringify(this.$route.params.id));
    this.examId = this.$route.params.id;
    this.loading = true;
    this.init();

  },
  methods: {
    init() {
      this.$api.planInfo({ id: this.examId }).then((res) => {
        if (res.status) {
          this.topTitle = res.data.title;
          this.id = res.data.id;
          this.starId = res.data.paper_id;
          this.newsList = res.data.news;
          this.data = res.data;
        } else {
          this.$common.errorToShow(res.msg);
        }
        this.loading = false;
      });
    },

    newsDetail(id) {
      const { href } = this.$router.resolve({
        name: "articledetail",
        query: { article_id: id },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text-prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    margin-bottom: 14px;

    &:nth-of-type(4) {
      margin-bottom: 30px;
    }
  }
  .class-box {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    .item {
      width: 220px;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgba(250, 250, 250, 1);
      img {
        width: 34px;
        height: 34px;
        display: block;
        margin-bottom: 17px;
      }
      .text-prc {
        width: 100%;
        height: 22px;
        font-size: 16px;
        text-align: center;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
</style>
